export default class Banner {
  readonly id: number
  readonly position: string 
  readonly bodyHtml: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.position = data.position
    this.bodyHtml = data.bodyHtml
  }
}
